/**
 * DI-3-F — what the uploader asks the gateway, as one injectable seam (the
 * runner's tests and the journeys' stubs replace it; the app uses the real
 * `inspection-3` / `intake` calls).
 */
import {
  completeUploadSession,
  getUploadSession,
  openUploadSession,
  type AuxManifestEntry,
  type IngestJobAccepted,
  type OpenUploadSessionBody,
  type UploadManifestEntry,
  type UploadSession,
  type UploadSessionStatus,
} from "../api/uploadSessions.js";
import { withholdIntake, type WithholdAccepted } from "../api/withhold.js";
import { fetchIntakeStatus, fetchMissingBlobs } from "../api/intake.js";
import type { IntakeStatus } from "../api/intakeTypes.js";

export interface UploadApi {
  /** M5-NODE-01 — `hint.reason`: the escape hatch's (inspection-3/v1 2.6.0). */
  open: (daId: string, hint: OpenUploadSessionBody) => Promise<UploadSession>;
  complete: (
    daId: string,
    sessionId: string,
    files: UploadManifestEntry[],
    /** DI-3-S75 — the set's `*_pos.txt` files; omitted when there is none. */
    auxFiles?: AuxManifestEntry[],
  ) => Promise<IngestJobAccepted>;
  poll: (daId: string, sessionId: string) => Promise<UploadSessionStatus>;
  withhold: (daId: string) => Promise<WithholdAccepted>;
  status: (daId: string) => Promise<IntakeStatus>;
  /** DI-3-S9 — the names whose originals the server knows it lacks (`listIntakeBlobs?state=missing`, every page). */
  missingBlobs: (daId: string) => Promise<ReadonlySet<string>>;
}

export const REAL_UPLOAD_API: UploadApi = {
  open: openUploadSession,
  complete: completeUploadSession,
  poll: getUploadSession,
  withhold: withholdIntake,
  status: fetchIntakeStatus,
  missingBlobs: fetchMissingBlobs,
};
